import { MultiSelect } from '@/shared/ui/multi-select'
import type { FC } from 'react'
import { useState } from 'react'
import { useEventsByTeamId } from '@/entities/event/api/hooks'
import type { BaseMemberMetaDto } from '@/entities/team'
import { useUpdateTeamMember } from '@/entities/team'

type TeamMemberEventsSelectProps = {
  teamId: string
  member: BaseMemberMetaDto
}

export const TeamMemberEventsSelect: FC<TeamMemberEventsSelectProps> = ({
  teamId,
  member,
}) => {
  const [assignedMemberEvents, setAssignedMemberEvents] = useState(
    () => member.eventIds,
  )
  const { data: teamEvents } = useEventsByTeamId({
    params: {
      teamId,
    },
    options: {
      enabled: !!teamId,
    },
  })

  const { mutate: updateTeamMember, isPending: isUpdatingTeamMember } =
    useUpdateTeamMember()

  return (
    <MultiSelect
      value={assignedMemberEvents}
      onChange={(newEventIds) => {
        setAssignedMemberEvents(newEventIds)
        updateTeamMember(
          {
            teamId,
            uidOrEmail: (member?.uid ?? member.email) as string,
            payload: {
              eventIds: newEventIds,
            },
          },
          {
            onError() {
              setAssignedMemberEvents(member.eventIds)
            },
          },
        )
      }}
      options={
        teamEvents?.map(({ id, name }) => ({
          value: id,
          label: name,
        })) ?? []
      }
      loading={isUpdatingTeamMember}
      placeholder="No events"
    />
  )
}
